import { render, staticRenderFns } from "./SideMenuView.vue?vue&type=template&id=9baa564a&"
import script from "./SideMenuView.vue?vue&type=script&lang=js&"
export * from "./SideMenuView.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports